import { Text } from "ui/Typography"
import PropTypes from "prop-types"
import { Divider, Flex } from "antd"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import moment from "moment"
import SnapshotPriceDetails from "../SnapshotPriceDetails"

const buildPaymentLine = (payment) => {
  if (!payment?.amount) return undefined
  const parts = [payment?.type]
  const { method, last4 } = payment
  if (method || last4) {
    const info = []
    if (method) info.push(method)
    if (last4) info.push(`••••${last4}`)
    parts.push(`(${info.join(" ")})`)
  }
  return { label: parts.filter(Boolean).join(" ").trim(), amount: payment.amount }
}

const UpdatedPriceDetailsItem = ({ history }) => {
  const { t } = useTranslation()
  const { id, payment_summary: paymentSummary, created_at: createdAt, payment_history } = history || {}
  const paymentLine = buildPaymentLine(payment_history?.find((item) => item))

  const dateTime = createdAt ? moment(createdAt).local().format("MM/DD/YYYY hh:mm A") : ""

  return (
    <Flex key={id || createdAt} vertical gap={spacings.XS}>
      <Text fw={500} size="lg">
        {t("client.payment.labels.updated_price_details", { dateTime })}
      </Text>
      <SnapshotPriceDetails paymentSummary={paymentSummary} paymentLine={paymentLine} />
    </Flex>
  )
}

UpdatedPriceDetailsItem.propTypes = {
  history: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    created_at: PropTypes.string,
    payment_summary: PropTypes.object
  })
}

const UpdatedPriceDetails = ({ priceChangeHistories }) => {
  if (!Array.isArray(priceChangeHistories) || !priceChangeHistories?.length) return null

  return (
    <Flex vertical gap={spacings.S} className="px-xl py-s">
      {priceChangeHistories.map((history) => (
        <>
          <UpdatedPriceDetailsItem key={history?.id || history?.created_at} history={history} />
          <Divider size="small" className="m-0" />
        </>
      ))}
    </Flex>
  )
}

UpdatedPriceDetails.propTypes = {
  priceChangeHistories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      created_at: PropTypes.string,
      payment_summary: PropTypes.object
    })
  )
}

export default UpdatedPriceDetails
